import { render, staticRenderFns } from "./parameter-definition-component.vue?vue&type=template&id=eb8c56a8&scoped=true&"
import script from "./parameter-definition-component.vue?vue&type=script&lang=ts&"
export * from "./parameter-definition-component.vue?vue&type=script&lang=ts&"
import style0 from "./parameter-definition-component.vue?vue&type=style&index=0&id=eb8c56a8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb8c56a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VSelect,VTextField})
